import { useGetReceivedFeedback } from "src/http";
import { useUserFeedbackSettings } from "../hooks";
import { UserFeedbackList } from "./UserFeedbackList";
import { UserFeedbackListSkeleton } from "./UserFeedbackListSkeleton";

interface Props {
  userId: string;
}

const UserFeedbackReceivedList = (props: Props) => {
  const { settings, updateSettings } = useUserFeedbackSettings(props.userId);
  const { data, isLoading } = useGetReceivedFeedback(props.userId, {
    filters: settings.receivedFeedbackFilters,
  });

  if (isLoading || data === undefined) {
    return <UserFeedbackListSkeleton />;
  }

  return (
    <UserFeedbackList
      title="Received"
      items={data}
      groupBy={settings.receivedFeedbackGroupByOption}
      filters={settings.receivedFeedbackFilters}
      onGroupByChanged={(value) => updateSettings({ receivedFeedbackGroupByOption: value })}
      onFilterByChanged={(filters) => updateSettings({ receivedFeedbackFilters: filters })}
    />
  );
};

export { UserFeedbackReceivedList };
